import { CLOUD_LAUNCH_PROMO } from '@/data/cloud';
const en = {
  m000: "Run DuckDB on Your iPhone! Exploring GizmoSQL's Lightning-Fast Mobile Data Warehouse",
  m001: "Independent coverage of the GizmoSQL iOS app — running DuckDB as a lightning-fast mobile data warehouse, right on your iPhone.",
  m002: "Philip Moore on the A/I Prosperity Podcast",
  m003: "GizmoData founder Philip Moore joins Torben Andersen to talk GizmoSQL, running DuckDB as an enterprise Arrow Flight SQL server, and cutting cloud warehouse costs.",
  m004: "TPC-H Benchmarks on GizmoSQL iOS, Fast 🚀",
  m005: "Running TPC-H benchmarks on GizmoSQL iOS — see the blazing-fast performance.",
  m006: "Introducing the New GizmoSQL iOS App",
  m007: "See the brand-new GizmoSQL iOS app, now available on the Apple App Store.",
  m008: "GizmoEdge at the DuckDB Developer Meeting",
  m009: "Presenting GizmoEdge at the inaugural DuckDB Developer Meeting in Amsterdam",
  m010: "Introducing the New Windows Release of GizmoSQL",
  m011: "We demonstrate how easy it is to run GizmoSQL - now available for Windows.",
  m012: "GizmoSQL in action",
  m013: "Run 10 TPC-H SF100GB benchmarks, at the same time!",
  m014: "GizmoEdge",
  m015: "The world's first IoT-powered distributed SQL engine",
  m016: "Featured Videos",
  m017: "See our products in action",
  m018: "Watch on YouTube",
};
export type Messages = typeof en;
export const messages = { en, 'pt-BR': {
  m000: "Execute DuckDB no seu iPhone! Conheça o data warehouse móvel de altíssimo desempenho do GizmoSQL",
  m001: "Cobertura independente do aplicativo GizmoSQL para iOS — executando DuckDB como um data warehouse móvel de altíssimo desempenho, diretamente no seu iPhone.",
  m002: "Philip Moore no podcast A/I Prosperity",
  m003: "Philip Moore, fundador da GizmoData, conversa com Torben Andersen sobre GizmoSQL, a execução de DuckDB como servidor Arrow Flight SQL empresarial e a redução de custos de data warehouses na nuvem.",
  m004: "Benchmarks TPC-H no GizmoSQL para iOS, com velocidade 🚀",
  m005: "Executando benchmarks TPC-H no GizmoSQL para iOS — veja o altíssimo desempenho.",
  m006: "Apresentamos o novo aplicativo GizmoSQL para iOS",
  m007: "Conheça o novo aplicativo GizmoSQL para iOS, já disponível na Apple App Store.",
  m008: "GizmoEdge no DuckDB Developer Meeting",
  m009: "Apresentação do GizmoEdge no primeiro DuckDB Developer Meeting, em Amsterdã",
  m010: "Apresentamos a nova versão do GizmoSQL para Windows",
  m011: "Mostramos como é fácil executar o GizmoSQL, agora disponível para Windows.",
  m012: "GizmoSQL em ação",
  m013: "Execute 10 benchmarks TPC-H SF100GB ao mesmo tempo!",
  m014: "GizmoEdge",
  m015: "O primeiro mecanismo SQL distribuído do mundo baseado em IoT",
  m016: "Vídeos em destaque",
  m017: "Veja nossos produtos em ação",
  m018: "Assista no YouTube",
} satisfies Messages };
